// import { projectImages } from "../utils/helpers";
import { founders, people } from "../Data/Study";
import { Card } from "./Card";
import { useLayoutEffect, useEffect, useRef } from "react";

export default function Study() {
  const elements = require.context(
    "../Images/Other",
    true,
    /\.(png|jpe?g|svg|mp4)$/,
  );

  const videoPath = elements
    .keys()
    .find(
      (p) =>
        p.includes("Interfaz_estudio") && p.split(".").slice(-1)[0] === "mp4",
    );
  const bannerSrc = elements(videoPath) ?? "";

  function findImg(name) {
    const img_path = elements
      .keys()
      .find((p) => p.includes(name) && p.split(".").slice(-1)[0] === "jpg");
    return elements(img_path);
  }

  // 1. Setup Refs for persistent memory and clean DOM targeting
  const titleContainerRef = useRef(null);
  const videoRef = useRef(null);
  const titleTopRef = useRef(0);
  const titleContainerHeight = useRef("auto");

  // 2. Extracted measurement logic into a reusable function
  const measureLayout = () => {
    const navbar = document.querySelector(".navbar");
    if (!navbar || !titleContainerRef.current || !videoRef.current) return;

    const navbar_height = navbar.offsetHeight;
    document.documentElement.style.setProperty(
      "--navbar-height",
      `${navbar_height}px`,
    );

    // Read exact geometry safely
    const header_rect = titleContainerRef.current.getBoundingClientRect();
    const video_height = videoRef.current.getBoundingClientRect().height;

    // Save to mutable ref (persists across renders)
    titleTopRef.current = video_height - header_rect.height;
    // titleTopRef.current = header_rect.top + window.scrollY;
    titleContainerHeight.current = `${header_rect.height}px`; // 3. Set explicit height to prevent layout shift when fixed
    // console.log("Accurate titleTop established:", titleTopRef.current);
    // console.log("title height:", titleContainerHeight.current);
  };

  useLayoutEffect(() => {
    // Measure on mount for the rest of the text layout
    measureLayout();
    const handleScroll = () => {
      const navbar = document.querySelector(".navbar");
      if (!navbar || !titleContainerRef.current) return;

      const navbar_height = Number(
        document.documentElement.style
          .getPropertyValue("--navbar-height")
          .split("px")[0],
      );

      // if (window.pageYOffset > 0) {
      //   navbar.classList.remove("single-project"); // Remove transparency for better readability when scrolling
      // } else {
      //   navbar.classList.add("single-project"); // Restore transparency on top
      // }

      // Calculate current absolute scroll vs element absolute layout position
      if (
        window.scrollY > titleTopRef.current - navbar_height &&
        window.scrollY > navbar_height
      ) {
        titleContainerRef.current.classList.add("is-header");
        titleContainerRef.current.style.height = `${navbar_height + parseInt(titleContainerHeight.current)}px`; // 4. Dynamically adjust title position based on actual navbar height
        navbar.classList.add("rmv-bg");
      } else if (window.scrollY > navbar_height) {
        titleContainerRef.current.classList.remove("is-header");
        titleContainerRef.current.style.height = "auto"; // Reset height when not fixed
        navbar.classList.remove("rmv-bg");
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", measureLayout); // Keep accurate on window resize

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", measureLayout); // Clean up any class changes on unmount
    };
  }, []); // Recalculate if project route id changes

  useEffect(() => {
    videoRef.current.addEventListener("loadeddata", () => measureLayout());
    document.querySelector(".navbar").classList.add("single-project");
    return () => {
      document.querySelector(".navbar").classList.remove("single-project");
    };
  }, []);

  return (
    <section className="study">
      <div className="titleAndImageContainer">
        <div ref={titleContainerRef} className="titleContainer">
          <h2>QUIÉNES SOMOS</h2>
        </div>
        <video
          ref={videoRef}
          style={{
            width: "100%",
            height: "auto",
            maxHeight: "80vh",
            objectFit: "cover",
            objectPosition: "center",
          }}
          src={bannerSrc}
          autoPlay
          loop
          muted
          // onLoadedData={measureLayout} // Recalculate when video metadata is loaded
        />
      </div>

      <div className="studyDataContainer">
        <div className="studyText">
          <p>
            Somos un estudio de arquitectura joven, enfocado en el diseño y la
            dirección de obras de distintas escalas y programas. Entendemos la
            arquitectura como una interfaz, un medio a través del cual las
            personas pueden establecer una relación más profunda y significativa
            con la realidad que habitan.
          </p>
          <p>
            Nuestro trabajo se enfoca en explorar esas conexiones, poniendo
            especial atención en las sensaciones y emociones que emergen del
            encuentro entre las personas y el espacio. Cada proyecto es
            concebido como una oportunidad para construir vínculos, articulando
            la funcionalidad con la materia, la luz y la proporción para
            amplificar la experiencia espacial.
          </p>
          <p>
            Nos caracteriza una forma de trabajo basada en la cercanía, la
            colaboración y la confianza, entendiendo el proceso de diseño como
            un intercambio constante con quienes nos eligen. Buscamos
            interpretar necesidades, traducir a objetivos y potenciar las
            distintas relaciones que atraviesan al proyecto. Acompañamos cada
            etapa con criterio técnico y sensibilidad proyectual, desde las
            primeras ideas hasta la finalización de la obra, construyendo
            propuestas que enriquezcan la experiencia de habitar.
          </p>
        </div>

        <div className="PeopleContainer columns-3">
          {founders.map((p) => {
            const img_src = findImg(p.img_src);
            return (
              <Card
                key={p.name}
                name={p.name}
                position={p.position}
                src={img_src}
              />
            );
          })}
        </div>
        <div className="PeopleContainer">
          {people.map((p) => {
            const img_src = findImg(p.img_src);
            return (
              <Card
                key={p.name}
                name={p.name}
                position={p.position}
                src={img_src}
              />
            );
          })}
        </div>
      </div>
      {/* <div className="projectImageGallery">
        {imageList["gallery"].map((src, index) => {
          if (src.split(".").slice(-1)[0] === "jpg") {
            return (
              <img
                key={index}
                src={src}
                alt={`${projectData.title} - ${index + 2}`}
              />
            );
          } else if (src.split(".").slice(-1)[0] === "mp4") {
            return <video key={index} src={src} autoPlay loop muted />;
          }
          return null; // Skip unsupported formats
        })}
      </div> */}
    </section>
  );
}
